import {createApp} from 'vue'
import ConfirmDeleteOverlay from './ConfirmDeleteOverlay'

const el = '.kb-component--confirm-delete-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ConfirmDeleteOverlayDOM)=>{
            const component = createApp(ConfirmDeleteOverlay).use(Store)
            component.mount(ConfirmDeleteOverlayDOM)
        })
    }
}